export default __webpack_public_path__ + "static/media/blog-img227.b582ec7a.jpg";